/*
  tr-reviews.js — 自前レビュー表示の小さな JS（NOB-1620 PR-5）。

  1. ライトボックス: [data-tr-lightbox] のボタン（snippets/tr-review-media.liquid）を押すと、ページに 1 個だけ作る
     <dialog class="tr-lightbox"> に写真（縮小版・data-srcset から画面に合う 960 / 1280 / 1600px）か動画（原本・controls 付き・
     自動再生なし）を出す。送った時に待たせないよう、一覧で読み込み済みの縮小版が足りる大きさならそれをそのまま使い、
     足りない時は前後の写真を先に読んでおく（押す前の pointerdown でも読み始める）。拡大用が届くまでは一覧の縮小版を
     同じ大きさで出しておく（真っ黒な待ち時間を作らない）。
     同じ data-group の中で前後に送る（レビュー内＝review_id / 帯＝strip-<section> / ギャラリー＝'gallery'）。
     絞り込みで隠れている枡は飛ばす。PC は写真の右、スマホは下に「そのレビュー」のペイン（星・日付・本文・署名）を出す
     （PR-5b v2・Amazon / Airbnb の型）。中身はボタンの data-review-id と同じ .tr-review[data-review-id] から複製する
     （ギャラリーのようにカードが無い面は caption だけ）。
     文言はセクションの data-lightbox-labels（JSON・ロケール由来）から読む＝この JS に日本語を直書きしない。
  2. 作例ギャラリーの絞り込み: [data-tr-gallery] の中のチップ（data-filter="model|scene"）で枡を hidden にする。
     JS が動かなければ全部出たまま（劣化しても使える）。テーマエディタがセクションを差し替えたとき
     （shopify:section:load）も初期化する。初期化済みの root は data-tr-gallery-ready で印を付けて 1 回だけ。
  3. 本文の「続きを読む」（PR-5b）: [data-tr-clamp] の本文を 5 行で切り（CSS の .tr-review__text--clamped）、
     実際に溢れている時だけボタンを足す。文言はセクションの data-read-more / data-read-less（ロケール由来）。
     JS が動かなければ全文のまま（切らない）。
  4. 一覧の絞り込み「写真・動画あり」（PR-5b v2・snippets/tr-review-toolbar.liquid）: 同じセクションの
     .tr-reviews__list[data-tr-list] の中の .tr-review（data-has-media）を hidden にする。対象は**描いてある範囲だけ**
     （並び替えは置かない＝一部だけを全体のように見せない）。チップと表示中の件数を更新し、母集団の集計は変えない。
     JS が無ければツールバーは hidden のまま（件数の範囲表示は Liquid が出す）。
  依存なし。Dawn の global.js があれば pauseAllMedia / overflow-hidden クラスを使う。
*/
(function () {
  'use strict';

  // 同じページに複数のセクション（カルーセル＋ギャラリー等）があると、この script タグが何度も読まれて
  // 実行される。2 回目以降は何もしない（ライトボックスの dialog が重なって開くのを防ぐ・Codex PR #144）
  if (window.__trReviewsInit) return;
  window.__trReviewsInit = true;

  var dialog = null;
  var stage = null;
  var caption = null;
  var counter = null;
  var original = null;
  var prevButton = null;
  var nextButton = null;
  var closeButton = null;
  var panel = null;
  var inner = null;
  var items = [];
  var index = 0;
  var opener = null;
  var labels = {};
  var touchStartX = null;
  // 拡大用の写真の候補の選び方。写真の枠は画面幅以下なので 100vw で伝える（PC は 1600、スマホは画面の実ピクセルに
  // 合う 960 / 1280 が選ばれる）。大きめに伝えるので、枠に収める表示（CSS の max-width / max-height）は今までと同じ
  var LIGHTBOX_SIZES = '100vw';
  // 先に読んでおいた写真（新しい順）。デコード済みの画像を持ち続けるとスマホのメモリを食うので数を絞る
  var PRELOAD_KEEP = 8;
  var preloaded = [];
  // 速く送った時に、前の写真の読み込み完了で今の写真を差し替えないための番号
  var renderToken = 0;
  // 最後に送った向き（1＝次へ・-1＝前へ）。先読みを進む向きに厚くする
  var direction = 1;

  function fill(template, values) {
    return String(template || '').replace(/\{(\w+)\}/g, function (_, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? values[key] : '';
    });
  }

  function readLabels(button) {
    var root = button.closest('[data-lightbox-labels]');
    if (!root) return;
    try {
      labels = JSON.parse(root.getAttribute('data-lightbox-labels')) || {};
    } catch (e) {
      labels = {};
    }
  }

  function icon(path) {
    return (
      '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24"><path d="' +
      path +
      '" stroke-linecap="round" stroke-linejoin="round"/></svg>'
    );
  }

  function build() {
    dialog = document.createElement('dialog');
    dialog.className = 'tr-lightbox';
    dialog.setAttribute('aria-label', labels.label || '');
    dialog.innerHTML =
      '<div class="tr-lightbox__inner">' +
      '<button type="button" class="tr-lightbox__button tr-lightbox__close">' +
      icon('M6 6l12 12M18 6L6 18') +
      '</button>' +
      '<button type="button" class="tr-lightbox__button tr-lightbox__prev">' +
      icon('M15 5l-7 7 7 7') +
      '</button>' +
      '<button type="button" class="tr-lightbox__button tr-lightbox__next">' +
      icon('M9 5l7 7-7 7') +
      '</button>' +
      '<div class="tr-lightbox__main">' +
      '<figure class="tr-lightbox__stage"></figure>' +
      '<div class="tr-lightbox__footer">' +
      '<p class="tr-lightbox__caption"></p>' +
      '<span class="tr-lightbox__counter"></span>' +
      '<a class="tr-lightbox__original" target="_blank" rel="noopener"></a>' +
      '</div>' +
      '</div>' +
      '<aside class="tr-lightbox__panel" hidden></aside>' +
      '</div>';
    document.body.appendChild(dialog);

    inner = dialog.querySelector('.tr-lightbox__inner');
    panel = dialog.querySelector('.tr-lightbox__panel');
    stage = dialog.querySelector('.tr-lightbox__stage');
    caption = dialog.querySelector('.tr-lightbox__caption');
    counter = dialog.querySelector('.tr-lightbox__counter');
    original = dialog.querySelector('.tr-lightbox__original');
    prevButton = dialog.querySelector('.tr-lightbox__prev');
    nextButton = dialog.querySelector('.tr-lightbox__next');
    closeButton = dialog.querySelector('.tr-lightbox__close');

    closeButton.addEventListener('click', close);
    prevButton.addEventListener('click', function () {
      step(-1);
    });
    nextButton.addEventListener('click', function () {
      step(1);
    });
    dialog.addEventListener('click', function (event) {
      // 背景（dialog 自身）を押したら閉じる。中身のクリックは無視
      if (event.target === dialog) close();
    });
    dialog.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') step(-1);
      if (event.key === 'ArrowRight') step(1);
    });
    dialog.addEventListener('close', onClosed);
    stage.addEventListener(
      'touchstart',
      function (event) {
        touchStartX = event.changedTouches[0].clientX;
      },
      { passive: true }
    );
    stage.addEventListener(
      'touchend',
      function (event) {
        if (touchStartX === null) return;
        var delta = event.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (Math.abs(delta) < 40) return;
        step(delta < 0 ? 1 : -1);
      },
      { passive: true }
    );
  }

  function applyLabels() {
    dialog.setAttribute('aria-label', labels.label || '');
    closeButton.setAttribute('aria-label', labels.close || 'Close');
    prevButton.setAttribute('aria-label', labels.prev || 'Previous');
    nextButton.setAttribute('aria-label', labels.next || 'Next');
    original.textContent = labels.original || 'Original';
    panel.setAttribute('aria-label', labels.review || '');
  }

  // そのレビューのペイン: ボタンの data-review-id と同じカードから星・日付・タイトル・本文・署名を複製する。
  // 本文は clamp の外側（.tr-review__text）ではなく <p> を複製するので全文が出る。「続きを読む」ボタンは複製しない
  function fillPanel(button) {
    var id = button.getAttribute('data-review-id');
    var article = id ? document.querySelector('.tr-review[data-review-id="' + id.replace(/"/g, '\\"') + '"]') : null;
    panel.innerHTML = '';
    if (!article) {
      panel.hidden = true;
      inner.classList.remove('tr-lightbox__inner--with-panel');
      return false;
    }
    ['.tr-review__head', '.tr-review__title', '.tr-review__body', '.tr-review__foot'].forEach(function (selector) {
      var node = article.querySelector(selector);
      if (!node) return;
      var clone = node.cloneNode(true);
      Array.prototype.forEach.call(clone.querySelectorAll('[id]'), function (el) {
        el.removeAttribute('id');
      });
      if (selector === '.tr-review__title') {
        // dialog の中に h3 を増やさない（見出しの階層が壊れる）。見た目は CSS で同じ
        var p = document.createElement('p');
        p.className = 'tr-review__title';
        p.textContent = clone.textContent;
        clone = p;
      }
      panel.appendChild(clone);
    });
    panel.hidden = false;
    panel.scrollTop = 0;
    inner.classList.add('tr-lightbox__inner--with-panel');
    return true;
  }

  function isVisible(button) {
    return !button.closest('[hidden]');
  }

  function collect(button) {
    var group = button.getAttribute('data-group');
    var all = Array.prototype.slice.call(document.querySelectorAll('[data-tr-lightbox]'));
    items = group
      ? all.filter(function (b) {
          return b.getAttribute('data-group') === group && isVisible(b);
        })
      : [button];
    index = items.indexOf(button);
    if (index < 0) {
      items = [button];
      index = 0;
    }
  }

  /**
   * 拡大用の写真を読み始め（済んでいればそれを返す）、その Image を返す。動画・URL の無いものは null。
   * 同じ URL・同じ srcset / sizes で読むので、表示用の img を作った時はブラウザのキャッシュから即座に出る
   */
  function preload(button, priority) {
    if (!button || button.getAttribute('data-type') === 'video') return null;
    var src = button.getAttribute('data-src');
    if (!src) return null;
    for (var i = 0; i < preloaded.length; i++) {
      if (preloaded[i].src !== src) continue;
      var hit = preloaded.splice(i, 1)[0];
      var failed = hit.img.complete && !hit.img.naturalWidth;
      // 先読み（low）の途中で表示する番になったら high で頼み直す（ブラウザは読み込み中の同じ URL を使い回し、
      // 優先度だけ上げる）。失敗していたら読み直す（Codex PR #154）
      var promote = priority === 'high' && hit.priority !== 'high' && !isLoaded(hit.img);
      if (!failed && !promote) {
        preloaded.unshift(hit);
        return hit.img;
      }
      break;
    }
    var img = new Image();
    img.decoding = 'async';
    if (priority) img.fetchPriority = priority;
    setLargeSource(img, button);
    preloaded.unshift({ src: src, img: img, priority: priority || '' });
    if (preloaded.length > PRELOAD_KEEP) preloaded.length = PRELOAD_KEEP;
    return img;
  }

  function setLargeSource(img, button) {
    var srcset = button.getAttribute('data-srcset');
    if (srcset) {
      img.sizes = LIGHTBOX_SIZES;
      img.srcset = srcset;
    }
    img.src = button.getAttribute('data-src');
  }

  function isLoaded(img) {
    return !!img && img.complete && img.naturalWidth > 0;
  }

  /**
   * 一覧で読み込み済みの縮小版が拡大表示に足りる大きさなら、その URL（足りなければ ''）。足りる時はそれをそのまま
   * 使う＝待ち時間ゼロ（2 倍・3 倍画面のスマホは一覧の 1 枚写真で 960 / 1600 を読み込み済みのことが多い）。
   * 足りるかは「画面の幅 × 画素密度（1600 が上限）」と縮小版の幅（URL の width=）で比べる
   */
  function loadedEnough(button) {
    var thumb = button && button.querySelector('img');
    if (!isLoaded(thumb)) return '';
    var url = thumb.currentSrc || thumb.src;
    var needed = Math.min(1600, Math.ceil(window.innerWidth * (window.devicePixelRatio || 1)));
    return transformWidth(url) >= needed ? url : '';
  }

  /** 縮小版の URL の幅（/cdn-cgi/image/width=N）。読めなければ 0 */
  function transformWidth(url) {
    var match = /\/cdn-cgi\/image\/width=(\d+)/.exec(url || '');
    return match ? Number(match[1]) : 0;
  }

  /**
   * 一覧の縮小版をそのまま使う時の srcset。その縮小版を一番小さい候補にして、それより大きい拡大用の候補だけを後ろに
   * 足す＝今の画面ではブラウザがその縮小版（読み込み済み）を選び、回転・ウィンドウを広げた・画素密度の高い画面へ
   * 移した時はより大きい候補へ上げられる（固定の URL だと開き直すまでぼやけたまま・Codex PR #154）
   */
  function reuseSrcset(url, button) {
    var width = transformWidth(url);
    var list = [url + ' ' + width + 'w'];
    // Cloudflare の URL は中にカンマを含む（width=960,quality=85,…）ので、カンマではなく空白で「URL 幅w,」の組に分ける
    var tokens = (button.getAttribute('data-srcset') || '').trim().split(/\s+/);
    for (var i = 0; i + 1 < tokens.length; i += 2) {
      var candidate = parseInt(tokens[i + 1], 10);
      if (candidate > width) list.push(tokens[i] + ' ' + candidate + 'w');
    }
    return list.join(', ');
  }

  /** 前後の写真を先に読んでおく（一覧の縮小版で足りるものは読まない） */
  function preloadNeighbor(button) {
    if (button && !loadedEnough(button)) preload(button, 'low');
  }

  /** 読み込みとデコードが済んだら（失敗しても）解決する */
  function whenReady(img) {
    if (isLoaded(img)) return Promise.resolve();
    if (typeof img.decode === 'function') return img.decode().catch(function () {});
    return new Promise(function (resolve) {
      img.addEventListener('load', resolve, { once: true });
      img.addEventListener('error', resolve, { once: true });
    });
  }

  function pauseVideo() {
    var video = stage.querySelector('video');
    if (video) video.pause();
  }

  function render() {
    var button = items[index];
    if (!button) return;
    pauseVideo();
    stage.innerHTML = '';
    var type = button.getAttribute('data-type');
    var src = button.getAttribute('data-src');
    var thumb = button.querySelector('img');
    if (type === 'video') {
      var video = document.createElement('video');
      video.controls = true;
      video.playsInline = true;
      video.preload = 'metadata';
      var poster = button.getAttribute('data-poster');
      if (poster) video.poster = poster;
      video.src = src;
      stage.appendChild(video);
    } else {
      var token = ++renderToken;
      var img = document.createElement('img');
      img.alt = thumb ? thumb.alt : '';
      img.decoding = 'async';
      var enough = loadedEnough(button);
      var full = enough ? null : preload(button, 'high');
      var preview = isLoaded(thumb) ? thumb.currentSrc || thumb.src : '';
      if (enough) {
        img.sizes = LIGHTBOX_SIZES;
        img.srcset = reuseSrcset(enough, button);
        img.src = enough;
      } else if (isLoaded(full) || !preview) {
        setLargeSource(img, button);
      } else {
        // 拡大用が届くまでは一覧の縮小版（読み込み済み）を枠いっぱいに出し、届いたら差し替える
        img.src = preview;
        img.classList.add('tr-lightbox__preview');
        whenReady(full).then(function () {
          // 読み込みに失敗したら縮小版のまま残す（壊れた画像に差し替えない）。次に開いた時は preload が読み直す
          if (token !== renderToken || !isLoaded(full)) return;
          setLargeSource(img, button);
          img.classList.remove('tr-lightbox__preview');
        });
      }
      stage.appendChild(img);
    }
    // 前後の写真を先に読んでおく（送った時に待たない）。今の写真より後回しにする。進む向きは 2 枚先まで
    // （続けて速く送っても追いつく）
    preloadNeighbor(items[index + direction]);
    preloadNeighbor(items[index + 2 * direction]);
    preloadNeighbor(items[index - direction]);
    var hasPanel = fillPanel(button);
    caption.textContent = button.getAttribute('data-caption') || '';
    caption.hidden = hasPanel;
    counter.textContent = items.length > 1 ? fill(labels.counter, { current: index + 1, total: items.length }) : '';
    var originalUrl = button.getAttribute('data-original');
    if (originalUrl) {
      original.href = originalUrl;
      original.hidden = false;
    } else {
      original.hidden = true;
    }
    var single = items.length < 2;
    prevButton.hidden = single;
    nextButton.hidden = single;
    prevButton.disabled = index <= 0;
    nextButton.disabled = index >= items.length - 1;
  }

  function step(delta) {
    var next = index + delta;
    if (next < 0 || next >= items.length) return;
    index = next;
    direction = delta < 0 ? -1 : 1;
    render();
  }

  function open(button) {
    readLabels(button);
    if (!dialog) build();
    applyLabels();
    collect(button);
    opener = button;
    direction = 1;
    render();
    if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
    document.body.classList.add('overflow-hidden');
    if (typeof dialog.showModal === 'function') {
      if (!dialog.open) dialog.showModal();
    } else {
      dialog.setAttribute('open', '');
    }
    closeButton.focus();
  }

  function close() {
    if (!dialog) return;
    if (typeof dialog.close === 'function' && dialog.open) {
      dialog.close();
    } else {
      dialog.removeAttribute('open');
      onClosed();
    }
  }

  function onClosed() {
    pauseVideo();
    stage.innerHTML = '';
    document.body.classList.remove('overflow-hidden');
    if (opener && typeof opener.focus === 'function') opener.focus();
    opener = null;
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-tr-lightbox]');
    if (!button) return;
    event.preventDefault();
    open(button);
  });

  // 押し始め（指が触れた・マウスを押した）の時点で拡大用を読み始める＝開くまでの待ちを縮める
  document.addEventListener(
    'pointerdown',
    function (event) {
      var button = event.target.closest && event.target.closest('[data-tr-lightbox]');
      if (button && !loadedEnough(button)) preload(button, 'high');
    },
    { passive: true }
  );

  // ── 作例ギャラリーの絞り込み ─────────────────────────────────────────
  function initGallery(root) {
    if (root.hasAttribute('data-tr-gallery-ready')) return;
    var grid = root.querySelector('[data-tr-gallery-grid]');
    if (!grid) return;
    root.setAttribute('data-tr-gallery-ready', '');
    var countNode = root.querySelector('[data-tr-gallery-count]');
    var emptyNode = root.querySelector('[data-tr-gallery-empty]');
    var template = root.getAttribute('data-shown-template') || '';
    var state = { model: '', scene: '' };

    function apply() {
      var tiles = Array.prototype.slice.call(grid.children);
      var shown = 0;
      tiles.forEach(function (tile) {
        var modelOk = !state.model || tile.getAttribute('data-model') === state.model;
        var scenes = tile.getAttribute('data-scenes') || '';
        var sceneOk = !state.scene || scenes.indexOf('|' + state.scene + '|') !== -1;
        var visible = modelOk && sceneOk;
        tile.hidden = !visible;
        if (visible) shown++;
      });
      if (countNode) countNode.textContent = fill(template, { count: shown });
      if (emptyNode) emptyNode.hidden = shown > 0;
    }

    root.addEventListener('click', function (event) {
      var chip = event.target.closest('.tr-chip[data-filter]');
      if (!chip || !root.contains(chip)) return;
      var kind = chip.getAttribute('data-filter');
      state[kind] = chip.getAttribute('data-value') || '';
      var group = chip.closest('.tr-gallery__filter-group') || root;
      Array.prototype.forEach.call(group.querySelectorAll('.tr-chip[data-filter]'), function (other) {
        other.setAttribute('aria-pressed', other === chip ? 'true' : 'false');
      });
      apply();
    });

    apply();
  }

  function initGalleries(scope) {
    if (scope && scope !== document && scope.matches && scope.matches('[data-tr-gallery]')) initGallery(scope);
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-tr-gallery]'), initGallery);
  }

  // ── 本文の「続きを読む」 ─────────────────────────────────────────────
  function clampLabels(block) {
    var root = block.closest('[data-read-more]');
    return {
      more: (root && root.getAttribute('data-read-more')) || 'More',
      less: (root && root.getAttribute('data-read-less')) || 'Less'
    };
  }

  // 5 行で切って溢れるかを測り、溢れる時だけボタンを出す。幅が変わると溢れ方も変わるので、resize でも測り直す
  // （Codex PR #148）。開いている間は触らない（読んでいる途中で閉じない）
  function measureClamp(block) {
    var body = block.querySelector('.tr-review__body');
    if (!body) return;
    // 絞り込みで隠れているカード（display: none）は高さが 0 で「溢れていない」と誤判定するので測らない。
    // 見せ直す時に initToolbar が測り直す（Codex PR #148）
    if (body.clientHeight === 0 && body.scrollHeight === 0) return;
    var button = block.querySelector('.tr-review__more');
    if (button && button.getAttribute('aria-expanded') === 'true') return;
    block.classList.add('tr-review__text--clamped');
    var overflows = body.scrollHeight > body.clientHeight + 2;
    if (!overflows) {
      block.classList.remove('tr-review__text--clamped');
      if (button) button.hidden = true;
      return;
    }
    if (!button) {
      var labels = clampLabels(block);
      button = document.createElement('button');
      button.type = 'button';
      button.className = 'tr-review__more';
      button.textContent = labels.more;
      button.setAttribute('aria-expanded', 'false');
      button.addEventListener('click', function () {
        var expanded = !block.classList.toggle('tr-review__text--clamped');
        button.textContent = expanded ? labels.less : labels.more;
        button.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        // 開いている間は resize で測り直さないので、閉じた時に今の幅で測り直す（広げた後に閉じて溢れなくなって
        // いればボタンを隠す・Codex PR #148）
        if (!expanded) measureClamp(block);
      });
      block.appendChild(button);
    }
    button.hidden = false;
  }

  function initClamp(block) {
    if (block.hasAttribute('data-tr-clamp-ready')) return;
    block.setAttribute('data-tr-clamp-ready', '');
    measureClamp(block);
  }

  function initClamps(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-tr-clamp]'), initClamp);
  }

  // ── 一覧の絞り込み（写真・動画あり） ──────────────────────────────────
  function initToolbar(toolbar) {
    if (toolbar.hasAttribute('data-tr-toolbar-ready')) return;
    var listId = toolbar.getAttribute('data-tr-toolbar');
    var root = toolbar.parentNode;
    var list = null;
    while (root && !list) {
      list = root.querySelector ? root.querySelector('.tr-reviews__list[data-tr-list="' + listId + '"]') : null;
      root = root.parentNode;
    }
    if (!list) return;
    toolbar.setAttribute('data-tr-toolbar-ready', '');
    var cards = Array.prototype.slice.call(list.querySelectorAll('.tr-review'));
    var withMedia = cards.filter(function (card) {
      return card.getAttribute('data-has-media') === '1';
    });
    // 写真付きが 0 件か全件なら絞る意味が無い（hidden のまま）
    if (withMedia.length === 0 || withMedia.length === cards.length) return;
    var template = toolbar.getAttribute('data-count-template') || '';
    var showingTemplate = toolbar.getAttribute('data-showing-template') || '';
    var totalCount = toolbar.getAttribute('data-total-count') || cards.length;
    var visibleCount = toolbar.parentNode.querySelector('[data-tr-visible-count]');
    var countAll = toolbar.querySelector('[data-tr-chip-count="all"]');
    var countMedia = toolbar.querySelector('[data-tr-chip-count="media"]');
    if (countAll) countAll.textContent = fill(template, { count: cards.length });
    if (countMedia) countMedia.textContent = fill(template, { count: withMedia.length });
    toolbar.hidden = false;

    function apply(mode) {
      cards.forEach(function (card) {
        var hide = mode === 'media' && card.getAttribute('data-has-media') !== '1';
        var revealed = card.hidden && !hide;
        card.hidden = hide;
        // 隠れている間に幅が変わっていても測れていないので、見せ直した時に「続きを読む」を測り直す
        if (revealed) Array.prototype.forEach.call(card.querySelectorAll('[data-tr-clamp]'), measureClamp);
      });
      Array.prototype.forEach.call(toolbar.querySelectorAll('.tr-chip[data-tr-filter]'), function (chip) {
        chip.setAttribute('aria-pressed', chip.getAttribute('data-tr-filter') === mode ? 'true' : 'false');
      });
      if (visibleCount) {
        visibleCount.textContent = fill(showingTemplate, {
          shown: mode === 'media' ? withMedia.length : cards.length,
          total: totalCount
        });
      }
    }

    toolbar.addEventListener('click', function (event) {
      var chip = event.target.closest('.tr-chip[data-tr-filter]');
      if (!chip || !toolbar.contains(chip)) return;
      apply(chip.getAttribute('data-tr-filter') || 'all');
    });
  }

  function initToolbars(scope) {
    Array.prototype.forEach.call((scope || document).querySelectorAll('[data-tr-toolbar]'), initToolbar);
  }

  var clampWidth = window.innerWidth;
  var clampTimer = null;
  window.addEventListener('resize', function () {
    if (window.innerWidth === clampWidth) return; // 高さだけの変化（スマホのアドレスバー等）は無視
    clampWidth = window.innerWidth;
    clearTimeout(clampTimer);
    clampTimer = setTimeout(function () {
      Array.prototype.forEach.call(document.querySelectorAll('[data-tr-clamp][data-tr-clamp-ready]'), measureClamp);
    }, 150);
  });

  initGalleries(document);
  initClamps(document);
  initToolbars(document);
  // テーマエディタがセクションを足した・描き直したとき（Codex PR #144）。ライトボックスは document への委譲なので不要
  document.addEventListener('shopify:section:load', function (event) {
    initGalleries(event.target);
    initClamps(event.target);
    initToolbars(event.target);
  });
})();
